import { type ReactElement } from 'react';
import { useSelector } from 'react-redux';

import { type RootState } from '@editor2/reducers/root';
import {
	type ExternalTool as ExternalToolType,
	type GoReactExternalTool
} from '@editor2/types/pageElements';

import JsonConfig from '../JsonConfig';
import GoReact from './GoReact';

interface Props<TElement extends ExternalToolType> {
	element: TElement;
	courseId: number;
}

const ExternalTool = <TElement extends ExternalToolType>(props: Props<TElement>): ReactElement => {
	const { element, courseId } = props;

	const { element_types } = useSelector((state: RootState) => state.courses[courseId].config);

	const tool_implementation = element_types[element.tool_name]['settings']['tool_implementation'];

	switch (tool_implementation) {
		case 'ExternalTools::GoReactTool':
			return (
				<GoReact
					key={element.family_id}
					courseId={courseId}
					element={element as GoReactExternalTool}
				/>
			);
		default:
			return <JsonConfig key={element.family_id} courseId={courseId} element={element} />;
	}
};

export default ExternalTool;
